import useDesignTokens from '@assetron/web-common/themes/useDesignTokens';
import { useTheme } from '@mui/material';
import { useMemo } from 'react';

const useSignUpCreatePassword = () => {
  const theme = useTheme();
  const tokens = useDesignTokens();

  const styles = useMemo(
    () => ({
      root: {
        width: '360px',
        marginTop: theme.sizeGuide['4xl'],
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'top',
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
      titleContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.sizeGuide.lg,
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.sizeGuide['4xl'],
        [theme.breakpoints.down('sm')]: {
          gap: theme.sizeGuide.sm,
        },
      },
      textContainer: {
        height: theme.sizeGuide['2xl'],
        display: 'flex',
        textAlign: 'center',
        alignContent: 'center',
        marginTop: theme.sizeGuide.lg,
        [theme.breakpoints.down('sm')]: {
          height: 'auto',
          flexDirection: 'column',
        },
      },
      signupDetailsFormInputBoxStyle: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.sizeGuide['2xl'],
        width: '360px',
        paddingBottom: theme.sizeGuide['3xl'],
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
      signupTextDetails: {
        width: 'auto',
        hieight: '36px',
        paddingBottom: theme.sizeGuide.xl,
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        gap: theme.sizeGuide['2xl'],
      },
      button: {
        marginTop: theme.sizeGuide['3xl'],
        marginBottom: theme.sizeGuide['4xl'],
        [theme.breakpoints.down('sm')]: {
          width: 'auto',
        },
      },
      description: {
        width: '100%',
        color: tokens.colors.text.secondary,
        textAlign: 'center',
      },
    }),
    [theme, tokens],
  );

  return styles;
};

export default useSignUpCreatePassword;
